/**
 * Drag the Words - form exports and hardcoded slug.
 * Registration is handled centrally in content-prompt/src/index.ts.
 */

export const DRAG_THE_WORDS_SLUG = 'gap_drag_words';

export { DragWordsForm } from './DragWordsForm';
export type { DragWordsMediaType, DragWordsSourceType, DragWordsFormState } from './types';
export { MEDIA_OPTIONS, DEFAULT_FORM_STATE } from './types';
export { QUESTION_TYPE_PRESETS, QUICK_CREATE_TEMPLATES } from './config';
export type { QuickCreateTemplate } from './config';
